import { observer } from "mobx-react-lite"

interface IHeaderProps {
	left?: JSX.Element | string
	center?: JSX.Element | string
	right?: JSX.Element | string
}

export const Header = observer(({ left, center, right }: IHeaderProps) => {
	return (
		<div className="flex w-full flex-row items-center justify-between">
			<div className="flex flex-1 justify-start">{left}</div>
			<div className="flex grow justify-center ">{center}</div>
			<div className="flex flex-1 justify-end">{right}</div>
		</div>
	)
})
